import api from 'api';
const validateAllUrl = '/api/events/:eventId/refund/merchandises/info';
const validateItemUrl = '/api/refund/merchandises/info';

export default {
    validate: (eventId, params) => params ? api.post({path:validateItemUrl.replace(':eventId', eventId), params:[params]}) : api.get({path:validateAllUrl.replace(':eventId', eventId)})
};